export default __webpack_public_path__ + "efee975e3222b7ce50804715f89c26f0.png";